import intlTelInput from "intl-tel-input";
import telUtils from "intl-tel-input/build/js/utils";

export const phoneNumberFormatter = (input, errorMessage) => {
  const reset = errorMsg => {
    errorMsg.classList.add("d-none");
  };

  const iti = intlTelInput(input, {
    preferredCountries: ["fr"],
    utilsScript: telUtils,
    formatOnDisplay: false,
    separateDialCode: false
  });

  const updatePhoneNumber = input => {
    const intNumber = iti.getNumber();
    input.value = intNumber;
  };

  input.addEventListener("change", () => {
    updatePhoneNumber(input);
  });

  input.addEventListener("countrychange", () => {
    updatePhoneNumber(input);
  });

  input.addEventListener("blur", () => {
    reset(errorMessage);
    if (input.value.trim()) {
      if (!iti.isValidNumber()) {
        errorMessage.classList.remove("d-none");
      }
    }
  });

  input.addEventListener("load", reset(errorMessage));
  input.addEventListener("change", reset(errorMessage));
  input.addEventListener("keyup", reset(errorMessage));
};
